const routePromo = () => '/promo';

export default routePromo;